function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 10.9981C21.9996 8.89599 21.397 6.83805 20.2633 5.06785C19.1297 3.29766 17.5126 1.88934 15.6035 1.00963C13.6944 0.129911 11.5732 -0.184364 9.49098 0.104005C7.40879 0.392375 5.45282 1.27131 3.85463 2.63677C2.25645 4.00222 1.08297 5.79702 0.473112 7.80867C-0.136742 9.82032 -0.15743 11.9646 0.413497 13.9876C0.984424 16.0107 2.12306 17.8278 3.6946 19.2238C5.26615 20.6199 7.20479 21.5364 9.28103 21.8649V14.1774H6.48643V10.9981H9.28103V8.57449C9.28103 5.81795 10.9227 4.2934 13.4361 4.2934C14.2609 4.30483 15.0839 4.37657 15.8983 4.50805V7.21524H14.5081C14.2717 7.18406 14.0314 7.20642 13.8049 7.28069C13.5783 7.35495 13.3714 7.47922 13.1993 7.64428C13.0273 7.80934 12.8946 8.01098 12.811 8.23426C12.7275 8.45755 12.6952 8.69677 12.7166 8.93422V10.9981H15.7675L15.2799 14.1779H12.719V21.8649C15.3066 21.4555 17.6631 20.136 19.3645 18.1439C21.0659 16.1518 22.0005 13.6178 22 10.9981Z",
  fill: "#1877F2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2882 14.1643L15.7769 10.9791H12.7231V8.91289C12.7012 8.67478 12.7332 8.4348 12.8168 8.21075C12.9003 7.98671 13.0332 7.78434 13.2056 7.6187C13.3781 7.45305 13.5856 7.32837 13.8129 7.25391C14.0401 7.17944 14.2812 7.15711 14.5182 7.18856H15.9083V4.47721C15.0926 4.34542 14.2682 4.27348 13.442 4.26196C10.9239 4.26196 9.27981 5.7877 9.27981 8.54899V10.9767H6.47986V14.162H9.27742V21.8649C10.4183 22.0428 11.5798 22.0428 12.7207 21.8649V14.1649L15.2882 14.1643Z",
  fill: "white"
});

const SvgIconFacebook = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-facebook.41feabc3.svg";
export { ForwardRef as ReactComponent };